import {z} from 'zod';

import i18n from '@dms/i18n';

import {hasAtMostDecimalPlaces} from '../../../../../utils/hasAtMostDecimalPlaces';

export const PurchasePriceCostsFormSchema = z.object({
  defaultDailyInterestRate: z
    .number()
    .min(0.01, i18n.t('general.errors.number.positive'))
    .nullable(),
  expectedDaysToSell: z.number().min(1, i18n.t('general.errors.number.positive')).nullable(),
  dailyStorageCost: z
    .number()
    .min(0, i18n.t('general.errors.number.greaterOrEqual', {min: 0}))
    .nullable(),
  fixedPurchaseCosts: z
    .number()
    .min(0, i18n.t('general.errors.number.greaterOrEqual', {min: 0}))
    .refine((value) => hasAtMostDecimalPlaces(value, 2), {
      message: i18n.t('general.validations.maximumDecimalPlaces', {
        maximum: 2,
      }),
    })
    .nullable(),
});

export type PurchasePriceCostsFormSchemaType = z.infer<typeof PurchasePriceCostsFormSchema>;
